import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "react-phone-input-2/lib/bootstrap.css";
import "react-phone-input-2/lib/style.css";

import { Formik, Form } from "formik";
import * as Yup from "yup";

import logowhite from "../../../assets/images/logowhite.svg";
import { userService } from "services";
import Images from "assets/images";
import useCurrentUser from "hooks/useCurrentUser";

const WORD_LIMIT = 1000;

const countWords = (text = "") => {
  if (!text.trim()) return 0;
  return text
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
};

const validationSchema = Yup.object({
  bio: Yup.string()
    .required("Please enter bio")
    .test(
      "word-count",
      `Bio cannot exceed ${WORD_LIMIT} words`,
      (value) => countWords(value || "") <= WORD_LIMIT
    ),
});

const Step2 = () => {
  const navigate = useNavigate();
  const { setUser: setCurrentUser } = useCurrentUser();
  const [serverError, setServerError] = useState(null);
  const LIVE_SITE_URL = process.env.REACT_APP_LIVE_SITE_URL;
  return (
    <div className="container-fluid login-page p-0">
      <div className="row relative">
        <div className="col-lg-7 pr-0">
          <div className="right-login-side">
            <div className="nav-bar-container">
              <Link to="/" className="nav-bar">
                <img alt="" src={Images.arrowleft} className="me-2 py-1" />
                Home
              </Link>
            </div>

            <div className="outer-div-form">
              <div className="form-div profile-form mb-5">
                <div className="tab-content-bg">
                  <div className="auth-tab-content authcontainer px-lg-5 px-3">
                    <div>
                      <p className="step-p">Step 2 of 3</p>
                      <div className="d-flex justify-content-between gap-2">
                        <div className="step-lines active"></div>
                        <div className="step-lines active"></div>
                        <div className="step-lines"></div>
                      </div>
                    </div>
                    <h4 className="text-capitalize text-center form-hreading fw-bold text-white">
                      Add Bio
                    </h4>

                    <Formik
                      initialValues={{ bio: "" }}
                      validationSchema={validationSchema}
                      onSubmit={async (values, { setSubmitting }) => {
                        setServerError(null);
                        const payload = {
                          step: "2",
                          bio: values.bio,
                        };

                        try {
                          const response = await userService.buildPilotProfile(payload);
                          localStorage.setItem(
                            "userData",
                            JSON.stringify(response?.data?.data)
                          );
                          setCurrentUser(response?.data?.data);
                          navigate("/profileStep3");
                        } catch (err) {
                          console.error(err?.response?.data?.message);
                          const msg = err?.response?.data?.message || "Something went wrong";
                          setServerError(msg);
                          // optional: attach to bio field instead of global error
                          // setFieldError("bio", msg);
                        } finally {
                          setSubmitting(false);
                        }
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        setFieldValue,
                        setFieldError,
                        isSubmitting,
                      }) => {
                        const wordCount = countWords(values.bio);
                        const charCount = values.bio.length;

                        const handleChangeBio = (e) => {
                          const newValue = e.target.value;
                          const newWordCount = countWords(newValue);

                          if (newWordCount > WORD_LIMIT) {
                            // Block update & show warning
                            setFieldError(
                              "bio",
                              `Bio cannot exceed ${WORD_LIMIT} words`
                            );
                            return;
                          }

                          // Clear error if within limit
                          if (errors.bio && newWordCount <= WORD_LIMIT) {
                            setFieldError("bio", undefined);
                          }

                          setFieldValue("bio", newValue);
                        };

                        const handlePasteBio = (e) => {
                          const pasteText = e.clipboardData.getData("text");
                          const target = e.target;
                          const { selectionStart, selectionEnd } = target;

                          const currentValue = values.bio || "";
                          const newValue =
                            currentValue.slice(0, selectionStart) +
                            pasteText +
                            currentValue.slice(selectionEnd);

                          const newWordCount = countWords(newValue);

                          if (newWordCount > WORD_LIMIT) {
                            e.preventDefault();
                            setFieldError(
                              "bio",
                              `Bio cannot exceed ${WORD_LIMIT} words. Please shorten your text before pasting.`
                            );
                            return;
                          }
                        };

                        return (
                          <Form>
                            <div className="mb-30 text-left">
                              <label>
                                Be sure to add your experience, years of flying, additional
                                drones owned, special certificates, video and photo editing
                                capabilities.
                              </label>
                              <div className="form-control-bg">
                                <div
                                  className="textrea-overlay w-100"
                                  style={{ marginTop: 20 }}
                                >
                                  <textarea
                                    className="form-control"
                                    placeholder="Type here"
                                    id="exampleFormControlTextarea1"
                                    rows="8"
                                    name="bio"
                                    value={values.bio}
                                    onChange={handleChangeBio}
                                    onPaste={handlePasteBio}
                                  ></textarea>
                                </div>
                              </div>

                              {/* Word + character count */}
                              <div className="d-flex justify-content-between mt-1 small">
                                <span className="text-muted" style={{ color: "white" }}>
                                  {wordCount} {wordCount === 1 ? "word" : "words"}
                                </span>

                              </div>

                              {/* Field error */}
                              {touched.bio && errors.bio && (
                                <div className="text-danger mt-2">{errors.bio}</div>
                              )}

                              {/* Server/global error */}
                              {serverError && (
                                <div className="text-danger mt-2">{serverError}</div>
                              )}
                            </div>

                            <div className="text-center ">
                              <button
                                type="submit"
                                className="btn btn-primary text-capitalize"
                                disabled={isSubmitting}
                              >
                                {isSubmitting ? "Please wait..." : "Next"}
                              </button>
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
              </div>

              <div className="d-flex mt-md-0 mt-2 flex-md-row flex-column bottom-ft justify-content-between auth-bottom-links">
                <div className="mb-lg-0 mb-3 d-flex justify-content-md-start justify-content-center">
                  <Link to={`${LIVE_SITE_URL}terms-conditions`}>Terms of Services</Link>
                  <Link to={`${LIVE_SITE_URL}privacy-policy`}>Privacy Policy</Link>
                </div>
                <div className="mb-lg-0 mb-3 d-flex justify-content-md-end justify-content-center">
                  <p>© 2023 SkyyTask. All rights reserved.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-5 pl-0 pr-0 pt-0">
          <div className="left-bg-form">
            <div className="logo-container w-100">
              <Link to="/" className="mx-auto mt-4 d-flex justify-content-center">
                <img alt="" src={logowhite} className="logo" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step2;
